import React, { PureComponent } from 'react';
import styled from 'styled-components';
import TextField from '../TextField';
import Theme from '../../theme';
import SearchIcon from '../../assets/svgs/search.svg';

import config from './config.json';

const Container = styled.div`
  position: relative;
`;

const BlackTextField = styled(TextField)`
  && {
    padding-right: 30px;
    margin: 0;

    &:focus {
      border-color: ${Theme.colours.black};
    }
  }
`;

const IconContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
`;

class SearchTextField extends PureComponent {
  loadSiteSearch360 = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    window.ss360Config = config;

    script.src = 'https://cdn.sitesearch360.com/sitesearch360-v11.min.js';
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  componentDidMount() {
    if (typeof window.ss360Config === 'undefined') {
      this.loadSiteSearch360();
    } else if (typeof window.SS360 !== 'undefined') {
      window.SS360.init();
    }
  }

  render() {
    return (
      <Container>
        <BlackTextField className="ss360SearchBox" placeholder="Search" />
        <IconContainer
          size={this.props.iconSize}
          onClick={this.props.onSearchIconClick}
        >
          <SearchIcon />
        </IconContainer>
      </Container>
    );
  }
}

export default SearchTextField;
